var is_touch_device = function() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

window.is_touch_device = is_touch_device;
